<template>
  <div>
    <div class="mb-3 gd-background">
       <section><!--franchise-->
        <v-parallax src="/static/img/background-apps.png" height="220">
          <v-layout column align-start justify-start class="white--text pl-5 pt-5">
            <v-flex xs12 md12 offset-md2>
              <div class="white--text text-md-left">
                <h1 class="text-executive-lg uppercase text-shadow">
                  RESET YOUR PASSWORD
                </h1>
              </div>
            </v-flex>
          </v-layout>
        </v-parallax>
      </section><!--/franchise-->
      <section>
        <v-flex xs12>
          <v-container grid-list-xl class="white--text text-md-left py-5" v-if="keyValidated">
            <v-layout row wrap align-center justify-center>
              <v-container grid-list-xl>
                <v-layout row wrap align-center>
                  <v-flex xs12 md12>
                    <v-card color="transparent" flat>
                      <div>
                        <div class="subheading text-courier-new-md-black text-sm-center">
                          <p>
                            <b>Change password</b>
                          </p>
                        </div>
                        <v-layout row wrap align-end justify-center class="mb-3">
                          <v-flex xs12 md6 class="text-courier-new-xs">
                            <v-text-field label="New Password" type="password" required hide-details
                                          v-model="updatePasswordParams.password"></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 class="text-courier-new-xs">
                            <v-text-field label="Confirm New Password" type="password" required hide-details
                                          v-model="updatePasswordParams.password_confirmation"></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-btn block dark class="text-helvetica-xxs remove-margin" small @click.stop="changePassword">Update Password</v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
          </v-container>
          <v-container grid-list-xl class="white--text text-md-left py-5" v-else>
            <v-layout row wrap align-center justify-center>
              <v-container grid-list-xl>
                <v-layout row wrap align-center>
                  <v-flex xs12 md12>
                    <v-card color="transparent" flat>
                      <div v-if="!successForgotPassword">
                        <div class="subheading text-courier-new-md-black text-sm-center">
                          <p>
                            <b>Please provide the email address that you used when you signed up for your account.</b>
                            <br>
                            If you forgot your email, please <a href="https://www.instagram.com/kopiketjil.uae/">contact us.</a>
                          </p>
                        </div>
                        <v-layout row wrap align-end justify-center class="mb-3">
                          <v-flex xs12 md6>
                            <v-text-field
                              color="black darken-2"
                              autofocus
                              name="subscribe-email-address"
                              single-line
                              v-model="email"
                              placeholder="Email address"
                              prepend-icon="mail"
                            ></v-text-field>
                            <div class="mb-3">
                              <small class="text-courier-new-xxs">
                                We will send you an email that will allow you to reset your password.
                              </small>
                            </div>
                            <v-btn block dark class="text-helvetica-xxs remove-margin" small @click.stop="requestForgotPassword">Reset password</v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                      <div v-else>
                        <v-flex class="subheading text-courier-new-md-black text-sm-center flex" align-center justify-center>
                          <p>
                            <b>Reset password success, please continue by checking your email</b>
                          </p>
                          <img src="https://cdn-icons-png.flaticon.com/512/8215/8215539.png" alt="" height="200">
                        </v-flex>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
          </v-container>
        </v-flex>
      </section>
    </div>
    <!-- <FooterApps /> -->
  </div>
</template>

<script>
import FooterApps from '@/components/FooterApps'

export default {
  name: 'rewards',
  components: {
    FooterApps
  },
  data () {
    return {
      email: '',
      loading: false,
      successForgotPassword: false,
      keyValidated: false,
      updatePasswordParams: {},
      key: ''
    }
  },
  computed: {
    query () {
      return this.$route.query
    },
    forgotToken () {
      return this.query.forgot_token
    }
  },
  created () {
    if (this.forgotToken) {
      this.loading = true
      this.$store.dispatch('validateKey', {
        data: {
          forgot_token: this.forgotToken
        },
        success: (res) => {
          this.key = res.key
          this.loading = false
          this.keyValidated = true
        },
        fail: () => {
          this.keyValidated = true
          this.$toast('Failed to validate token')
          this.loading = false
        }
      })
    }
  },
  methods: {
    requestForgotPassword () {
      this.loading = true
      this.$store.dispatch('forgotPassword', {
        data: {
          email: this.email
        },
        success: (res) => {
          this.successForgotPassword = true
          this.email = ''
          this.loading = false
        },
        fail: () => {
          this.successForgotPassword = true
          this.$toast('Failed to forgot password')
          this.loading = false
        }
      })
    },
    changePassword () {
      this.loading = true
      this.$store.dispatch('changePassword', {
        data: Object.assign({}, this.updatePasswordParams),
        success: (res) => {
          this.updatePasswordParams = {}
          this.loading = false
          this.$toast('Success update password, please try to login')
          this.$router.push('/')
        },
        fail: () => {
          this.$toast('Failed to update password')
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue